import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IObjekteQueryShapes, IObjekteResponse, ObjekteQueryFilterConfig } from 'fa-kt.types';

import { ObjekteService } from '../service';

@Component({
  selector: 'fa-kt-objekte-filter',
  templateUrl: './objekte-filter.component.html',
  styleUrls: ['./objekte-filter.component.css'],
})
export class ObjekteFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public ObjekteFilterConfig: IFilterConfig<IObjekteResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objekte: ObjekteService,
  ) {
    this.ObjekteFilterConfig = ObjekteQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.objekte.shapes$.subscribe((shapes: IObjekteQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ObjekteFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ObjekteFilterConfig[index].selections = shapes;
  }
}
